"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _transformationMatrixJs = require("transformation-matrix-js");

var getMatrix = function getMatrix(scaleX, scaleY, translateX, translateY, rotation) {
  var transformMatrix = new _transformationMatrixJs.Matrix();
  transformMatrix.transform(scaleX, 0, 0, scaleY, translateX, translateY);
  transformMatrix.rotateDeg(rotation);
  return transformMatrix;
};

var _default = getMatrix;
exports["default"] = _default;